import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule, RowArgs  } from '@progress/kendo-angular-grid';

import { ManageCustomersComponent, displayType } from './manage-customers.component';
import { BlockingScreenModule } from '../../../common/component/blocking-screen/blocking-screen.module';
import { UsersListModule } from '../shared/users-list/users-list.module';
import { AddEditCustomerModule } from './add-edit-customer/add-edit-customer.module';
import { ManageCustomersRoutingModule } from './manage-customers-routing.module';


@NgModule({
  imports: [
    CommonModule
    ,GridModule
    ,UsersListModule
    ,AddEditCustomerModule
    ,BlockingScreenModule
    ,ManageCustomersRoutingModule
  ],
  declarations: [ManageCustomersComponent],
  exports: [ManageCustomersComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ManageCustomersModule { }
